export default {
  seller: {
    search: 'sellerSearch',
    list: 'getSellers',
    details: 'sellerDetails',
    contactData: 'sellerContactData',
    address: 'getAddress',
    fiscalData: 'sellerFiscalData',
    deliveryDetails: 'sellerDeliveryDetails',
  },
  sellerOrders: {
    list: 'getSellerOrders',
  },
  buyer: {
    search: 'buyerSearch',
    list: 'getBuyers',
    details: 'buyerDetails',
    contactData: 'buyerContactData',
    fiscalData: 'buyerFiscalData',
    addresses: 'buyerAddresses',
  },
  staff: {
    kamList: 'kamList',
  },
  carts: {
    list: 'getCartOrders',
    details: 'getCartDetails',
  },
  globalOrder: {
    list: 'getGlobalOrders',
  },
  detailOrder: {
    list: 'getDetailOrders',
    details: 'getOrderDetails',
    deliveryInfo: 'getDeliveryInfo',
    events: 'getOrderEvents',
    filters: 'filters',
  },
  product: {
    search: 'productSearch',
    catalog: 'productCatalog',
    catalogSearch: 'catalogSearch',
    catalogSeller: 'catalogSeller',
  },
  fiscal: {
    getCFDIUses: 'getCfdiUses',
    getFiscalRegimes: 'getFiscalRegimes',
  },
  catalog: {
    masterProductList: 'getCatalogMasterProducts',
    masterProductSearch: 'catalogMasterProductSearch',
    sellerProductList: 'getCatalogSellerProducts',
    sellerProductSearch: 'catalogSellerProductSearch',
    categoryList: 'getCatalogCategories',
    categorySearch: 'catalogCategorySearch',
  },
  disbursement: {
    balance: 'getBalance',
  },
};
